/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostAIAssistantReceptionQRCodeResponseTypename = "PostAIAssistantReceptionQRCodeResponse" as const;

/**
 *
 * @export
 * @interface PostAIAssistantReceptionQRCodeResponse
 */
export interface PostAIAssistantReceptionQRCodeResponse {
  /**
   * base64 encoded PNG image data
   * @type {string}
   * @memberof PostAIAssistantReceptionQRCodeResponse
   */
  image: string;
  /**
   *
   * @type {string}
   * @memberof PostAIAssistantReceptionQRCodeResponse
   */
  mimeType: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostAIAssistantReceptionQRCodeResponse
   */
  readonly __typename?: string;
}

export function PostAIAssistantReceptionQRCodeResponseFromJSON(json: any): PostAIAssistantReceptionQRCodeResponse {
  return PostAIAssistantReceptionQRCodeResponseFromJSONTyped(json, false);
}

export function PostAIAssistantReceptionQRCodeResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostAIAssistantReceptionQRCodeResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostAIAssistantReceptionQRCodeResponseTypename,

    image: json["image"],
    mimeType: json["mime_type"],
  };
}

export function PostAIAssistantReceptionQRCodeResponseToJSON(
  object?: PostAIAssistantReceptionQRCodeResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    image: value.image,
    mime_type: value.mimeType,
  };
}
